import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@fluentui/react-components";
import { ArrowResetRegular } from "@fluentui/react-icons/svg/arrow-reset";
import { useSidebarFilterResetViewModel } from "./SidebarFilterReset.ViewModel";

interface SidebarFilterResetProps {
  isCollapsed: boolean;
}

/**
 * Clears every filter at once, from the pane's heading.
 *
 * Only shown while something is filtered: an always-present reset on an
 * unfiltered board is a button that does nothing.
 */
const SidebarFilterReset: React.FC<SidebarFilterResetProps> = ({
  isCollapsed,
}) => {
  const { t } = useTranslation();
  const vm = useSidebarFilterResetViewModel();

  if (!vm.hasActiveFilters) {
    return null;
  }

  const label = t("layout.sidebar.resetFilters", { count: vm.activeCount });

  return (
    <Tooltip content={label} relationship="label" positioning="after">
      <button
        type="button"
        className="sidebar-nav__filter-reset"
        onClick={vm.resetFilters}
      >
        <ArrowResetRegular />
        {!isCollapsed && <span>{t("layout.sidebar.reset")}</span>}
      </button>
    </Tooltip>
  );
};

export default SidebarFilterReset;
